import React, { useState } from "react";
import {
  Box,
  TextField,
  MenuItem,
  Button,
  Typography,
  FormControl,
  FormLabel,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Paper,
  Select,
  Chip,
} from "@mui/material";
import AddIcon from "@mui/icons-material/Add";
import CancelIcon from "@mui/icons-material/Cancel";
import DemoTable from "../../../components/table/demoTable";

const componentOptions = [
  "Search Bar",
  "Filters",
  "Download",
  "Client Info",
  "Item List",
  "Total Calculation",
  "PDF Preview",
  "Payment Status",
  "Notes",
];

const PageBuilder = () => {
  const [pages, setPages] = useState([
    { name: "Invoice List", type: "Table", components: ["Search Bar", "Filters", "Download"] },
    { name: "Create Invoice", type: "Form", components: ["Client Info", "Item List", "Total Calculation"] },
    { name: "Invoice Details", type: "View", components: ["PDF Preview", "Payment Status", "Notes"] },
  ]);
  const [newPage, setNewPage] = useState({ name: "", type: "", components: [] });
  const [openDialog, setOpenDialog] = useState(false);
  const [editIndex, setEditIndex] = useState(null);

  const addPage = () => {
    if (newPage.name.trim() && newPage.type.trim()) {
      setPages([...pages, newPage]);
      setNewPage({ name: "", type: "", components: [] });
    }
  };

  const saveEditedPage = () => {
    if (newPage.name.trim() && newPage.type.trim()) {
      setPages((prev) =>
        prev.map((page, i) => (i === editIndex ? newPage : page))
      );
      setNewPage({ name: "", type: "", components: [] });
      setOpenDialog(false);
      setEditIndex(null);
    }
  };
  

  const removePage = (index) => {
    setPages(pages.filter((_, i) => i !== index));
  };

  const handleEdit = (index) => {
    setNewPage(pages[index]);
    setEditIndex(index);
    setOpenDialog(true);
  };

  const handleDelete = (index) => {
    removePage(index);
  };

  const columns = [
    { id: "sno", label: "S.No", minWidth: 10, align: "center" },
    { id: "name", label: "Page Name", minWidth: 150, align: "center" },
    { id: "type", label: "Type", minWidth: 150, align: "center" },
    { id: "components", label: "Components", minWidth: 200, align: "center" },
    { id: "action", label: "Actions", minWidth: 100, actionType: { edit: true, delete: true }, align: "center" },
  ];

  const transformSchemas = (schema) =>
    schema.map((item, index) => ({
      sno: index + 1,
      name: item.name,
      type: item.type,
      components: item.components.join(", "),
      action: index,
    }));

  const modifiedRows = pages ? transformSchemas(pages) : [];

  return (
    <Box sx={{ display: "flex", flexDirection: "column", p: 3 }}>
      <Typography variant="h4" fontWeight="bold" textAlign="center" sx={{ mb: 2 }}>
        Invoice Page Builder
      </Typography>

      <Paper elevation={3} sx={{ p: 3, mb: 4 }}>
        <DemoTable columns={columns} rows={modifiedRows} handleEdit={handleEdit} handleDelete={handleDelete} />

        {/* Add Page Form */}
        <Box sx={{ display: "flex", flexDirection: "row", gap: 2, alignItems: "center", mt: 2 }}>
  <TextField
    fullWidth
    placeholder="Page Name"
    value={newPage.name}
    onChange={(e) => setNewPage({ ...newPage, name: e.target.value })}
    sx={{ flex: 1 }}
  />
  <FormControl fullWidth sx={{ flex: 1 }}>
    <Select
      displayEmpty
      value={newPage.type}
      onChange={(e) => setNewPage({ ...newPage, type: e.target.value })}
      variant="outlined"
    >
      <MenuItem value="" disabled>
        Select Type
      </MenuItem>
      <MenuItem value="Table">Table</MenuItem>
      <MenuItem value="Form">Form</MenuItem>
      <MenuItem value="View">View</MenuItem>
    </Select>
  </FormControl>

  {/* Multi-Select for Components */}

<FormControl fullWidth sx={{ flex: 2 }}>
  <Select
    multiple
    displayEmpty
    value={newPage.components}
    onChange={(e) => setNewPage({ ...newPage, components: e.target.value })}
    renderValue={(selected) =>
      selected.length ? (
        <Box sx={{ display: "flex", flexWrap: "wrap", gap: 0.5 }}>
          {selected.map((value) => (
           <Chip
           key={value}
           label={value}
           onMouseDown={(event) => event.stopPropagation()} // Prevents the menu from opening
           onDelete={() =>
             setNewPage((prevPage) => ({
               ...prevPage,
               components: prevPage.components.filter((comp) => comp !== value),
             }))
           }
           deleteIcon={<CancelIcon />}
         />
         
          ))}
        </Box>
      ) : (
        <Typography color="gray">Select Components</Typography>
      )
    }
  >
    {componentOptions.map((comp) => (
      <MenuItem key={comp} value={comp}>
        {comp}
      </MenuItem>
    ))}
  </Select>
</FormControl>


  <Button variant="contained" color="primary" startIcon={<AddIcon />} onClick={addPage}>
    Add
  </Button>
</Box>

      </Paper>

      {/* Edit Page Dialog */}
      <Dialog open={openDialog} onClose={() => setOpenDialog(false)} maxWidth="sm" fullWidth>
        <DialogTitle>Edit Page</DialogTitle>
        <DialogContent sx={{ display: "flex", flexDirection: "column", gap: 2, mt: 1 }}>
          <FormControl fullWidth>
            <FormLabel>Page Name</FormLabel>
            <TextField
              fullWidth
              placeholder="Page Name"
              value={newPage.name}
              onChange={(e) => setNewPage({ ...newPage, name: e.target.value })}
            />
          </FormControl>
          <FormControl fullWidth>
            <FormLabel>Select Type</FormLabel>
            <TextField
              select
              fullWidth
              value={newPage.type}
              onChange={(e) => setNewPage({ ...newPage, type: e.target.value })}
              variant="outlined"
            >
              <MenuItem value="Table">Table</MenuItem>
              <MenuItem value="Form">Form</MenuItem>
              <MenuItem value="View">View</MenuItem>
            </TextField>
          </FormControl>
          <FormControl fullWidth>
  <FormLabel>Components</FormLabel>
  <Select
    multiple
    value={newPage.components}
    onChange={(e) => setNewPage({ ...newPage, components: e.target.value })}
    renderValue={(selected) => (
      <Box sx={{ display: "flex", flexWrap: "wrap", gap: 0.5 }}>
        {selected.map((value) => (
         <Chip
         key={value}
         label={value}
         onMouseDown={(event) => event.stopPropagation()} // Prevents the menu from opening
         onDelete={() =>
           setNewPage((prevPage) => ({
             ...prevPage,
             components: prevPage.components.filter((comp) => comp !== value),
           }))
         }
         deleteIcon={<CancelIcon />}
       />
       
        ))}
      </Box>
    )}
  >
    {componentOptions.map((comp) => (
      <MenuItem key={comp} value={comp}>
        {comp}
      </MenuItem>
    ))}
  </Select>
</FormControl>

        </DialogContent>
        <DialogActions>
          <Button onClick={() => setOpenDialog(false)} color="secondary">
            Cancel
          </Button>
          <Button onClick={saveEditedPage} variant="contained" color="primary">
            Update
          </Button>
        </DialogActions>
      </Dialog>
    </Box>
  );
};

export default PageBuilder;
